









import { Component, Vue, Prop } from 'vue-property-decorator';
import { AppText, AppHeading } from '../../typography';
import AppWrapper from '../AppWrapper';

@Component({
  components: {
    AppText,
    AppHeading,
    AppWrapper,
  },
})
export default class AppHeadingTextBlock extends Vue {
  @Prop({ type: String, default: '' })
  readonly name: string;

  @Prop({ type: String, default: '' })
  readonly value: string;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppHeadingTextBlock/AppHeadingTextBlock.vue